import { render } from "./QuickMark.vue?vue&type=template&id=72273a70"
import script from "./QuickMark.vue?vue&type=script&lang=js"
export * from "./QuickMark.vue?vue&type=script&lang=js"

import "./QuickMark.vue?vue&type=style&index=0&id=72273a70&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__